import images from "../assets/carousel/index.js";
import logos from "../assets/logos/companies/index.js";

const companyList = {
  Seed: [
    {
      name: "Treasure Trove",
      logo: logos["treasureTrove"],
      subText: "FinTech, Collectibles",
      imgUrl: images["treasureTrove"],
      url: "https://www.treasuretrove.com/",
      liner:
        "Collectibles holding company acquiring and compounding value in investment-grade cultural assets.",
    },
    {
      name: "10a Labs",
      logo: logos["10ALabs"],
      subText: "AI, Research",
      imgUrl: images["10ALabs"],
      url: "https://10alabs.com/",
      liner:
        "AI safety and threat intelligence platform protecting frontier AI systems from emerging risks.",
    },
    {
      name: "Vega Claims",
      logo: logos["vegaClaims"],
      subText: "AI, InsurTech",
      imgUrl: images["vegaClaims"],
      url: "https://www.vegaclaims.com",
      liner:
        "AI-native insurance claims administrator combining automation with expert claims handling.",
    },
    {
      name: "Dimensional",
      logo: logos["dimensional"],
      subText: "Robotics",
      imgUrl: images["dimensional"],
      url: "https://dimensionalos.com/",
      liner:
        "Operating system for managing, automating, and optimizing physical spaces.",
    },
    {
      name: "ProSights",
      logo: logos["prosights"],
      subText: "AI, FinTech",
      imgUrl: images["prosights"],
      url: "http://prosights.co",
      liner:
        "Data transformation platform that converts fragmented enterprise data into AI-ready systems.",
    },
    {
      name: "Nurl Health",
      logo: logos["nurl"],
      subText: "AI, HealthTech",
      imgUrl: images["nurl"],
      url: "https://nurl.health/",
      liner:
        "Real-time biometric intelligence platform that identifies behavioral health risks through continuous monitoring.",
    },

    {
      name: "Tabflows",
      logo: logos["tabflows"],
      imgUrl: images["tabflows"],
      subText: "HealthTech",
      url: "https://link.tabflows.com/linkedin",
      liner:
        "Healthcare operations platform that reduces administrative burden for clinics and providers.",
    },
    {
      name: "Turnout",
      logo: logos["turnout"],
      imgUrl: images["turnout"],
      subText: "Consumer Services",
      url: "https://www.turnout.co/",
      liner:
        "Government services platform that helps people navigate complex programs and access benefits.",
    },
    {
      name: "Hedral",
      logo: logos["hedral"],
      imgUrl: images["hedral"],
      subText: "AI, AEC Industry",
      url: "https://www.hedral.co/",
      liner:
        "Backed by Khosla Ventures, Valor Equity Partners, and Tishman Speyer, Hedral is reinventing the ancient craft of building design.",
    },
  ],
  "Series A": [
    {
      name: "Spacial",
      logo: logos["spacial"],
      imgUrl: images["spacial"],
      subText: "AI, AEC Industry",
      url: "https://spacial.io/",
      liner:
        "AI-powered engineering platform that automates structural and MEP plan generation for residential construction projects.",
    },
    {
      name: "Copia Automation",
      logo: logos["copia"],
      imgUrl: images["copia"],
      subText: "AI, Manufacturing",
      url: "https://copia.io/",
      liner:
        "Industrial DevOps platform for managing the lifecycle of industrial automation code.",
    },
    {
      name: "Kai",
      logo: logos["kai"],
      imgUrl: images["kai"],
      subText: "PropTech",
      url: "http://www.kai.pro",
      liner:
        "AI-powered renovation platform that automates project planning, assessment, and execution workflows.",
    },
    {
      name: "ElectronX",
      logo: logos["electronx"],
      imgUrl: images["electronx"],
      subText: "FinTech",
      url: "https://www.electronx.com/",
      liner:
        "Regulated power derivatives exchange for managing short-term electricity price risk.",
    },
    {
      name: "Engageli",
      logo: logos["engageli"],
      imgUrl: images["engageli"],
      subText: "EducationTech",
      url: "https://www.engageli.com",
      liner:
        "Collaborative learning platform designed to improve engagement and peer-to-peer learning.",
    },
  ],
  "Series B": [
    {
      name: "Atlas Invest",
      logo: logos["atlasInvest"],
      imgUrl: images["atlasInvest"],
      subText: "FinTech",
      url: "https://atlas-invest.co/",
      liner:
        "Real estate credit platform modernizing financing and capital markets infrastructure.",
    },
    {
      name: "Tulu",
      logo: logos["tulu"],
      imgUrl: images["tulu"],
      subText: "PropTech",
      url: "https://www.tulu.io/",
      liner:
        "Shared access platform that enables on-demand use of everyday products and services.",
    },
    {
      name: "Spade",
      logo: logos["spade"],
      imgUrl: images["spade"],
      subText: "FinTech",
      url: "https://spade.com/",
      liner:
        "Transaction data enrichment platform that turns raw payment data into actionable merchant intelligence.",
    },
  ],
  "Series C": [
    {
      name: "Rhino",
      logo: logos["rhino"],
      imgUrl: images["rhino"],
      subText: "PropTech",
      url: "https://www.sayrhino.com",
      liner:
        "Security deposit alternative platform that improves housing affordability and access for renters.",
    },
    {
      name: "Reserv",
      logo: logos["reserv"],
      imgUrl: images["reserv"],
      subText: "InsurTech",
      url: "https://www.reserv.com/",
      liner:
        "Property and casualty claims platform built to modernize claims administration and operations.",
    },
    {
      name: "Insitro",
      logo: logos["insitro"],
      imgUrl: images["insitro"],
      subText: "AI, BioTech",
      url: "https://www.insitro.com/",
      liner:
        "AI-driven biotechnology platform that uses machine learning to uncover the mechanisms of human disease.",
    },
  ],
  "Series D": [
    {
      name: "Nova Credit",
      logo: logos["novaCredit"],
      imgUrl: images["novaCredit"],
      subText: "FinTech",
      url: "https://www.novacredit.com/",
      liner:
        "Credit infrastructure platform that helps businesses assess risk using alternative credit data.",
    },
    {
      name: "Nirvana",
      logo: logos["nirvana"],
      imgUrl: images["nirvana"],
      subText: "InsurTech",
      url: "http://www.nirvanatech.com",
      liner:
        "Commercial insurance platform that uses real-time data to improve underwriting and risk management.",
    },
  ],
  "Pre-IPO": [
    {
      name: "FutureSecure AI",
      logo: logos["futureSecureAi"],
      imgUrl: images["futureSecureAi"],
      subText: "AI Tech",
      url: "https://www.futuresecure.ai/",
      liner:
        "Enterprise AI workforce platform deploying AI co-workers to automate business operations at scale.",
    },
    {
      name: "Ionic",
      logo: logos["ionic"],
      imgUrl: images["ionic"],
      subText: "Energy Data Infrastructure",
      url: "https://ionicdigital.com/",
      liner:
        "Powered land and data center development platform supporting next-generation AI and high-performance computing infrastructure.",
    },
  ],
  Public: [
    {
      name: "American Bitcoin",
      logo: logos["americanBTC"],
      imgUrl: images["americanBTC"],
      subText: "Bitcoin",
      url: "https://www.abtc.com/",
      liner:
        "Bitcoin infrastructure and accumulation platform focused on expanding domestic mining capacity.",
    },
  ],
  "Non-Profit": [
    {
      name: "Align Bio",
      logo: logos["align"],
      imgUrl: images["align"],
      subText: "Biotech",
      url: "https://alignbio.org/",
      liner:
        "Scientific research infrastructure organization improving access to research methods, tools, and data.",
    },
    {
      name: "Pioneer Labs",
      logo: logos["pioneerLabs"],
      imgUrl: images["pioneerLabs"],
      subText: "BioTech, Non-Profit",
      url: "https://pioneer-labs.org",
      liner:
        "Synthetic biology nonprofit engineering microbes for space exploration and off-world manufacturing.",
    },
  ],
};

const companyCategory = [
  "Seed",
  "Series A",
  "Series B",
  "Series C",
  "Series D",
  "Pre-IPO",
  "Public",
  "Non-Profit",
];

export { companyList, companyCategory };
